import React from 'react';

interface ArticleSchemaProps {
  title: string;
  description: string;
  datePublished: string;
  dateModified?: string;
  authorName?: string;
  imageUrl?: string;
  keywords?: string;
}

const ArticleSchema: React.FC<ArticleSchemaProps> = ({
  title,
  description,
  datePublished,
  dateModified,
  authorName = 'RadonLab Network',
  imageUrl = 'https://radonmap.ca/Radon%20Map.jpg',
  keywords,
}) => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description: description,
    image: imageUrl,
    datePublished: datePublished,
    dateModified: dateModified || datePublished,
    author: {
      '@type': 'Organization',
      name: authorName,
      url: 'https://radonmap.ca',
    },
    publisher: {
      '@type': 'Organization',
      name: 'RadonMap Canada',
      url: 'https://radonmap.ca',
      logo: {
        '@type': 'ImageObject',
        url: 'https://radonmap.ca/Radon%20Map.jpg',
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': typeof window !== 'undefined' ? window.location.href : 'https://radonmap.ca',
    },
    keywords: keywords,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default ArticleSchema;
